// src/theme/index.js
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

import { createAppTheme } from "./createAppTheme";
import GlobalStyles from "./globalStyles";

ThemeConfig.propTypes = {
  children: PropTypes.node,
  // keep your existing app-level boolean
  dark: PropTypes.bool,
};

export default function ThemeConfig({ children, dark = true }) {
  const mode = dark ? "dark" : "light";
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
